import { Switch } from 'antd'
import React from 'react'
import useSettingsV2 from './hooks/useSettingsV2'

export default function Admin() {
  const { settingsPolling, setSettingsPolling } = useSettingsV2()

  if (!localStorage.getItem('admin')) {
    return null
  }

  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: 8 }}>
      <div>Refresh auto :</div>
      <Switch checked={settingsPolling} onChange={setSettingsPolling} />
    </div>
  )
}
